// @flow


import type {
    PhotoEBadgeQueryFailedAction,
    PhotoEBadgeQueryStartAction,
    PhotoEBadgeQuerySuccessAction
} from "../actions/ebadge/photo/photoEBadgeQueryAction";
import type {PhotoEBadge} from "../components/ebadge/photo/PhotoEBadgeQueryResult";
import type {PhotoEBadgeSearchCriteria} from "../components/ebadge/photo/PhotoEBadgeSearchForm";
import type {EBadgeButtonActionSuccessAction} from "../actions/ebadge/eBadgeButtonAction";
import * as _ from "lodash";

export type PhotoEBadgeQueryState = {
    eBadges: Array<PhotoEBadge>,
    totalResult: number,
    isLoading: boolean,
    currentPage: number,
    criteria?: PhotoEBadgeSearchCriteria,
    error?: any
}

const INITIAL_STATE: PhotoEBadgeQueryState = {
    eBadges: [],
    totalResult: -1,
    isLoading: false,
    currentPage: 0
};

type ActionCollection = PhotoEBadgeQuerySuccessAction | PhotoEBadgeQueryStartAction | PhotoEBadgeQueryFailedAction
    | EBadgeButtonActionSuccessAction;


function handleEBadgeButtonActionSuccess(action: EBadgeButtonActionSuccessAction, state: PhotoEBadgeQueryState): PhotoEBadgeQueryState {
    let index = _.findIndex(state.eBadges, (e) => e.registrationCode === action.registrationCode);
    let targetBadge: PhotoEBadge = state.eBadges[index];
    if (targetBadge) {

        switch (action.actionType) {
            case "validatePhoto":
                targetBadge.verifyStatus = 'Y';
                break;
            case "invalidatePhoto":
                targetBadge.verifyStatus = 'N';
                break;
            default:
                break;
        }
        let result = [].concat(state.eBadges);
        result.splice(index, 1, targetBadge);

        return {
            ...state,
            isLoading: false,
            eBadges: result,
            error: undefined
        }
    } else {
        return state;
    }
}

export default function reducer(state: PhotoEBadgeQueryState = INITIAL_STATE, action: ActionCollection): PhotoEBadgeQueryState {
    switch (action.type) {
        case "ebadge/photo/QUERY_START_ACTION":
            return {
                ...state,
                error: undefined,
                currentPage: action.criteria.page,
                isLoading: true,
                criteria: action.criteria
            };

        case "ebadge/photo/QUERY_SUCCESS_ACTION":
            return {
                ...state,
                error: undefined,
                eBadges: action.eBadges,
                totalResult: action.totalResult,
                isLoading: false
            };
        case "ebadge/photo/QUERY_FAILED_ACTION":
            return {
                ...INITIAL_STATE,
                error: action.error,
                isLoading: false
            };
        case "ebadge/BUTTON_ACTION_SUCCESS_ACTION":
            return handleEBadgeButtonActionSuccess(action, state);
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/PhotoEBadgeReducer.js